import { useClientBookingContext } from "@/contexts/clientBookingContext";
import useBookingClientDetails from "@/hooks/booking/useBookingClientDetails";
import ClientDetails from "./clientDetails";

export default function BookingClientDetails() {
  const { collectCardInformation } = useClientBookingContext();
  const { onSubmit } = useBookingClientDetails();

  return (
    <ClientDetails
      onSubmit={onSubmit}
      collectCardInformation={collectCardInformation}
    />
  );
}
